import { NavLink } from '@susu/headless-commerce/features/navigation/components/ClientNavLink/NavLink'
import { NavSeparator } from '@susu/headless-commerce/features/navigation/components/NavSeparator'
import type { NavigationGroup } from '@susu/headless-commerce/features/navigation/domain'
import { generateIdentifier } from '@susu/headless-commerce/utils/identifier'
import { isNotUndefined } from '@susu/undefined'
import classNames from 'classnames'
import styles from './NavGroup.module.scss'

export type NavGroupProps = {
  className?: string
  group: NavigationGroup
  isSubMenu?: boolean
}

export const NavGroup = ({
  className,
  group,
  isSubMenu = false,
}: NavGroupProps) => {
  const listClass = classNames(
    {
      [styles['nav__list']]: !isSubMenu,
      [styles['nav__submenu-list']]: isSubMenu,
    },
    className,
  )

  return (
    <>
      <NavSeparator group={group} />
      {isNotUndefined(group.title) && (
        <span
          className={styles['nav__submenu-label']}
          data-testid="label-highlights-custom-made-sub-menu"
        >
          {group.title}
        </span>
      )}
      <ul className={listClass} data-testid="nav-group">
        {group.items?.map((item) => (
          <NavLink
            fontStyling={group.fontStyling}
            isSubMenu={isSubMenu}
            item={item}
            key={generateIdentifier()}
          />
        ))}
      </ul>
    </>
  )
}
